import type { Place, Event } from "../../../types";
import type { PageLoad } from "./$types";
import { error } from "@sveltejs/kit";
import { parseId } from "../../../params/slug";

export const load: PageLoad = async function ({ params, parent }) {
  const id = parseId(params.id);

  const { events, places, heraldMap } = await parent();

  const event = events.find((e) => e.id == id);

  if (event == null) {
    error(404, "Unable to find event");
  }

  return {
    event: event as Event,
    places: places as Place[],
    map: heraldMap,
    pageTitle: event.title,
    pageDescription: event.description
  };
};
